import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import DualListBox from "../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import { Toast } from "react-bootstrap";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import { DatePicker, DatePickerProps } from "antd";
import dayjs, { Dayjs } from "dayjs";

type Permission = { id: number; name: string };

type Admin = {
  permissions: Array<number>;
  name: string | null;
  id: number;
};

interface ErrorMessages {
  name?: string[];
}

type Agent = {
  id: number;
  username: string;
}

interface Target {
  agent?: number;
  week_start_date?: string;
  target?: number;

}

const AddTargetForWizklubDailySalesTarget = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [chosenPermissions, setChosenPermissions] = useState<Permission[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [agents, setAgents] = useState<Agent[]>([]);
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const [selectedAgent, setSelectedAgent] = useState<Option | null>(null);
  const [newTicket, setNewTicket] = useState({
    agent: 0,
    date: "", // string in "YYYY-MM-DD" format
    target_conversion_time: 0,
  });

  const [toastMessage, setToastMessage] = useState("");
  useEffect(() => {
    if ((showSolidDangerToast || showSolidSuccessToast) === true) {
      setTimeout(() => setShowSolidDangerToast(false), 5000);
      setTimeout(() => setshowSolidSuccessToast(false), 5000);
    }
  }, [toastMessage])
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const handlePermissionsChange = (selected: Permission[]) => {
    setChosenPermissions(selected);
    setNewAdmin({
      ...newAdmin,
      permissions: selected.map((permission) => permission.id),
    });
  };
  const [newAdmin, setNewAdmin] = useState<Admin>({
    name: null,
    id: 0,
    permissions: [],
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchPermissionsData = async () => {
    const resposne = await fetch(
      `${webApi}/user/get_permissions_dropdown/`,
      options
    );
    return await resposne.json();
  };

  const fetchAgents = async () => {
    const resposne = await fetch(
      `${webApi}/teammgmt/get_team_members_by_teammgmt/2/`,
      options
    );
    const data = await resposne.json();
    setAgents(data);
  };

  const agentOptions = agents.map((p) => ({
    value: p.id.toString(),
    label: p.username,
  }));

  const fetchData = async () => {
    setIsLoading(true); // Start loading
    try {
      // const [permissionsData] = await Promise.all([fetchPermissionsData()]);

      // setPermissions(permissionsData.results);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    if (!checkPermission("add_dailycallconversion", "dailycallconversion")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData();
      fetchAgents();
    }
  }, [userPermissions]);

  const handleDateChange: DatePickerProps['onChange'] = (date: Dayjs | null) => {
    setNewTicket((prev) => ({
      ...prev,
      date: date ? date.format("YYYY-MM-DD") : "",
    }));
  };



  const updateData = async () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newTicket),
    };
    const url = `${webApi}/wizklub/wizklub_daily_call_conversion_report_view/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      setErrorMessage(errorData);
      setToastMessage(errorData.non_field_errors);
      if (toastMessage !== "") {
        setShowSolidDangerToast(true);
      }
      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await updateData();
      navigate(routes.wizklubDailyTargets);
    } catch (error) { }
    finally {
      setIsLoading(false)
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewAdmin({ ...newAdmin, [name]: value || null });
  };

  const handleAgentChange = (selected: Option | null) => {
    const priority = agents.find(
      (p) => p.id === parseInt(selected?.value || "")
    );
    setSelectedAgent(
      priority
        ? {
          value: priority.id.toString(),
          label: priority.username,
        }
        : null
    );
    setNewTicket({
      ...newTicket,
      agent: priority?.id ?? 0,
    });
  };

  // const handleDateChange = (date: Date | null) => {
  //   if (date && date.getDay() === 1) {
  //     setNewTicket(prev => ({
  //       ...prev,
  //       week_start_date: date.toISOString().split("T")[0],
  //     }));
  //   } else {
  //     alert("Please select a Monday.");
  //   }
  // };

  const handleTargetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewTicket(prev => ({
      ...prev,
      target_conversion_time: parseInt(e.target.value, 10) || 0,
    }));
  };


  useEffect(() => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);
  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Add Sales Target</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard1}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.wizklubDailyTargets}>Wizklub Daily Target</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Target</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Row */}
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              {/* Add Group */}
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",

                }}
              >
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div
                      className="mb-3 me-3"
                      style={{
                        flex: "1 1 100%",
                        maxWidth: "300px",
                        marginRight: "15px",
                        width: "300px",
                      }}
                    >
                      <label className="form-label">Agent</label>
                      <CommonSelect
                        className="select"
                        options={agentOptions}
                        onChange={handleAgentChange}
                        value={selectedAgent}
                        isRequired
                      />
                    </div>
                    <div
                      className="mb-3 me-3"
                      style={{
                        flex: "1 1 100%",
                        maxWidth: "300px",
                        marginRight: "15px",
                        width: "300px",
                      }}
                    >
                      <label className="form-label">Date</label>
                      <DatePicker
                        value={newTicket.date ? dayjs(newTicket.date) : null}
                        onChange={handleDateChange}
                        format="YYYY-MM-DD"
                        placeholder="Select a date"
                        className="form-control"
                        required
                      />

                    </div>

                    <div
                      className="mb-3 me-3"
                      style={{
                        flex: "1 1 100%",
                        maxWidth: "300px",
                        marginRight: "15px",
                        width: "300px",
                      }}
                    >
                      <label className="form-label">Target in minutes</label>
                      <input
                        type="number"
                        className="form-control"
                        value={newTicket.target_conversion_time}
                        onChange={handleTargetChange}
                        required
                      />
                    </div>

                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.wizklubDailyTargets}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight: "5px",
                        }}
                      >
                        Cancel
                      </Link>
                      <button className="btn btn-primary" type="submit" disabled={isLoading}>
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* /Add Group */}
            </div>
          </div>
          {/* /Row */}
          <Toast
            show={showSolidDangerToast}
            onClose={handleSolidDangerToastClose}
            id="solidDangerToast"
            className="colored-toast bg-danger text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          <Toast
            show={showSolidSuccessToast}
            onClose={handleSolidSuccessToastClose}
            id="solidSuccessToast"
            className="colored-toast bg-success text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </div>
      </div>
    </div>
  );
};

export default AddTargetForWizklubDailySalesTarget;
